export default __webpack_public_path__ + "static/media/farcry.b7debd66.jpeg";